import { useNavigate } from 'react-router-dom';
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext, useRef } from "react"

import TextImagesPreEditor from "../preEditors/textImagesPreEditor"
import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import TemplateEditor from '../components/templateEditor';

import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';
import {ExclamationCircleIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import { CcCheckbox, InputText, InputNumber, FileSelector } from '../commonComponents/inputFields';
import { getErrorListFromYupError, getErrorMessage, snippetDataValidationSchemaBase } from '../components/helperErrors'
import { FormControlLabel, FormGroup, Switch } from '@mui/material';

export function TextImagesElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  validationErrorsList: 
  */

  //const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetHref, setSnippetHref] = useState('')
  const [templateId, setTemplateId] = useState(undefined);
  //const [templateUrlParameters, setTemplateUrlParameters] = useState([]);
  const cacheTemplateUrlParameters = useRef({}) //!!!this is used otherwise getTemplateUrlParameters gets fired all the times

  //const [fallbackMode, setFallbackMode] = useState('image'); //can be 'image', 'parameters', 'mixed'
  const [snippetSettings, setSnippetSettings] = useState(undefined)
  const defaultSnippetSettings = {fallbackMode: 'image', useFallback: false,
                                  fallback: {
                                      image: {longer: 3, shorter: 3, imgB64: ''},
                                      parameters: {longer: 3, shorter: 3, imgB64: ''},
                                    }
                                  }

  const addUrlParamsToDefaultSettings = (params) => {
    // function to update defaultSnippetSettings with the url params from a template
    const paramsValuesPairs = params.map(p => {return {pName: p, pValue: ''}})
    const newParameters = {...defaultSnippetSettings.fallback.parameters, defaultParamsValues: paramsValuesPairs}
    const newFallback = {...defaultSnippetSettings.fallback, parameters: newParameters}

    //console.log({...defaultSnippetSettings, fallback: newFallback})
    return {...defaultSnippetSettings, fallback: newFallback}
  }


  useEffect(() => {
    if (props.templateId === undefined && props.snippetInfo === undefined) return;

    const doJobAsync = async () => {
      if (props.templateId) { //new      
        setTemplateId(props.templateId)
        const params = await getTemplateUrlParameters(props.templateId)
        const newDefaults = addUrlParamsToDefaultSettings(params)
        setSnippetSettings(newDefaults)
      }

      if (props.snippetInfo) { //we are in edit
        setSnippetName(props.snippetInfo.snippetName)
        setSnippetDesc(props.snippetInfo.snippetDesc)
        setSnippetHref(props.snippetInfo.href)
        setTemplateId(props.snippetInfo.templateId)
        const params = await getTemplateUrlParameters(props.snippetInfo.templateId)

        
        if (props.snippetInfo.snippetSettings) setSnippetSettings(props.snippetInfo.snippetSettings)
        else {
          const newDefaults = addUrlParamsToDefaultSettings(params)
          setSnippetSettings(newDefaults)
        }
      }

    }

    doJobAsync()
 
  }, [props.templateId, props.snippetInfo])


  const getTemplateUrlParameters = async (templateId) => {
    if (cacheTemplateUrlParameters.current[templateId]) {
      return cacheTemplateUrlParameters.current[templateId]
    }

    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Templates/urlParams/${templateId}`;
      const response = await axios.get(url);
      const data = response.data;

      cacheTemplateUrlParameters.current[templateId] = data
      return data

    } catch (error) {
      console.log(error);
    }
  }


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 12,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};
    result.templateId = templateId;
    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.href = snippetHref;
    result.snippetSettings = snippetSettings
    if (props.snippetInfo?.snippetId > 0 ) result.snippetId = props.snippetInfo.snippetId
    //result.timerDate = selectedTimerDate;
    //result.timerDateTimeZone = selectedTimeZoneId;
    //result.timerSettings = newTimerSettings ? JSON.stringify(newTimerSettings) : JSON.stringify(timerSettings);

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
      //console.log(result)
  }
    return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleSnippetHrefChange = (newValue) => {
    
    setSnippetHref(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('href', newValue))
  }
  const handleSnippetSettingsChange = (propName, propValue) => {    
    const newSettings = {...snippetSettings, [propName]: propValue}
    setSnippetSettings(newSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
  }
  const handleFallbackConditionChange = (fallbackMode, conditionName, conditionValue) => {
    //we need to prevent to have the same condition checkbox checked in both 'image' and 'parameters' modes


    const newConditions = {...snippetSettings.fallback[fallbackMode], [conditionName]: conditionValue}
    const newFallback = {...snippetSettings.fallback, [fallbackMode]: newConditions}

    if (conditionValue && ['isEmpty', 'isLonger', 'isShorter'].includes(conditionName))
    {
      if (fallbackMode === 'image') {
        newFallback.parameters[conditionName] = false
      }
      if (fallbackMode === 'parameters') {
        newFallback.image[conditionName] = false
      }
    }

    const newSettings = {...snippetSettings, fallback: newFallback}
    setSnippetSettings(newSettings)

    //console.log(newSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
  }
  const handleFallbackParametersChange = (index, pValue) => {
    const newDefaultParamsValues = [...snippetSettings.fallback.parameters.defaultParamsValues]
    const newP = {...newDefaultParamsValues[index], pValue: pValue}
    newDefaultParamsValues.splice(index, 1, newP)

    const newParameters = {...snippetSettings.fallback.parameters, defaultParamsValues: newDefaultParamsValues}
    const newFallback = {...snippetSettings.fallback, parameters: newParameters}
    const newSettings = {...snippetSettings, fallback: newFallback}
    setSnippetSettings(newSettings)

    //console.log(newSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
  }


  return <div>
  <div className='flex flex-col gap-4 justify-center items-center'>
      <div className="w-2/3 mt-10 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
    <div className="sm:col-span-3">
      <InputText
                displayName="Code name"
                value={snippetName}
                onChange={(val) => {handleSnippetNameChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetName')}
            />
    </div>

    <div className="sm:col-span-3">
      <InputText
                displayName="Description"
                value={snippetDesc}
                onChange={(val) => {handleSnippetDescChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
            />
    </div>


    <div className="sm:col-span-6">
      <InputText
                displayName="Href"
                value={snippetHref}
                onChange={(val) => {handleSnippetHrefChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'href')}
            />
    </div>

    {snippetSettings &&
    <div className='sm:col-span-6 border rounded px-2 py-1 text-ccColorDarkTeal font-poppins'>
      <div className='flex flex-row items-center gap-x-3 mb-1'>
        <div className='font-semibold '>Fallback options</div>
        <FormGroup>
          <FormControlLabel control={<Switch
                                      checked={snippetSettings.useFallback}
                                      onChange={(e) => handleSnippetSettingsChange('useFallback', e.target.checked)}
                                      inputProps={{ 'aria-label': 'controlled' }}
                                      sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                  />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'></div>}
          />
        </FormGroup>
      </div>

      {snippetSettings.useFallback && <>
        <div class="inline-flex rounded-md shadow-sm font-poppins w-full" role="group">
          <div className={`cursor-pointer px-4 py-2 w-1/3 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${(snippetSettings.fallbackMode === 'image') ? 'bg-gray-200' : 'bg-white'}`}
                onClick={()=>handleSnippetSettingsChange('fallbackMode', 'image')}>
            <div>
              Default image
            </div>
            <div className='text-sm mt-2 font-normal'>Show your uploaded image when the fallback conditions are met</div>
          </div>
          <div className={`cursor-pointer px-4 py-2 w-1/3 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${snippetSettings.fallbackMode === 'parameters' ? 'bg-gray-200' : 'bg-white'}`}
              onClick={()=>handleSnippetSettingsChange('fallbackMode','parameters')}>
            <div>
              Default parameters
            </div>
            <div className='text-sm mt-2 font-normal'>Show this same element with default parameter values when the fallback conditions are met</div>
          </div>
          <div className={`cursor-pointer px-4 py-2 w-1/3 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${snippetSettings.fallbackMode === 'mixed' ? 'bg-gray-200' : 'bg-white'}`}
              onClick={()=>handleSnippetSettingsChange('fallbackMode','mixed')}>
            <div>
              Mixed mode
            </div>
            <div className='text-sm mt-2 font-normal'>Show either the default image or use default parameters when the fallback conditions are met</div>
          </div>
        </div>

        {(snippetSettings.fallbackMode === 'image' || snippetSettings.fallbackMode === 'mixed') && <div className='mt-2 flex flex-row gap-x-12'>
            <div>
              <div className='flex flex-row items-center gap-x-1'>
                <div className='font-semibold'>Conditions</div>
                <InfoToolTip 
                        placement='right'
                        headLine='Multiple Parameters notice'
                        message="If your Element is using multiple parameters, it is enough that one meets the coditions below to apply the fallback."
                    />
              </div>
              <div className='flex flex-col'>
                <CcCheckbox
                    displayName={<div>Parameter is empty</div>}
                  checked={snippetSettings.fallback.image.isEmpty}
                  onChange={(e) => {handleFallbackConditionChange('image', 'isEmpty', e.target.checked);}}
                />
                <div className='flex flex-row items-center gap-x-1'>
                  <CcCheckbox
                      displayName={<div>Parameter is longer than</div>}
                    checked={snippetSettings.fallback.image.isLonger}
                    onChange={(e) => {handleFallbackConditionChange('image', 'isLonger', e.target.checked);}}
                  />
                  <div className='w-32 font-poppins'>
                    <InputNumber displayName="" small
                      min={1} max={100} incr={1}
                      onChange={(val) => {handleFallbackConditionChange('image', 'longer', val);}}
                      value={snippetSettings.fallback.image.longer}
                    />
                  </div>
                  <div>characters</div>
                
                </div>
                <div className='flex flex-row items-center gap-x-1'>
                  <CcCheckbox
                      displayName={<div>Parameter is shorter than</div>}
                    checked={snippetSettings.fallback.image.isShorter}
                    onChange={(e) => {handleFallbackConditionChange('image', 'isShorter', e.target.checked);}}
                  />
                  <div className='w-32 font-poppins'>
                    <InputNumber displayName="" small
                      min={1} max={100} incr={1}
                      onChange={(val) => {handleFallbackConditionChange('image', 'shorter', val);}}
                      value={snippetSettings.fallback.image.shorter}
                    />
                  </div>
                  <div>characters</div>
                
                </div>

              </div>
              {getErrorMessage(props.validationErrorsList, 'fallbackImageModeAtLeastOneCheckbox')?.length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5 ml-2" aria-hidden="true" />

                {getErrorMessage(props.validationErrorsList, 'fallbackImageModeAtLeastOneCheckbox')}
                </div>
              }
            </div>

            <div className='h-[330px] flex flex-col items-center gap-y-2'>
              <div className='font-semibold'>Default Image</div>
              {(snippetSettings.fallback.image.imgB64 === '') && <div className='bg-slate-200 rounded p-4 mt-2 w-[300px] h-[200px] flex flex-col justify-center items-center'>
                    <Iconify icon="carbon:no-image" width={200} />
                    <div className='font-poppins font-semibold'>No image uploaded</div>
                </div>

              }
              {snippetSettings.fallback.image.imgB64 !== '' &&
                <div className='bg-slate-200 rounded p-4 mt-2 w-[300px] h-[200px] flex justify-center'>
                  <div className='relative h-full' >

                      <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${snippetSettings.fallback.image.imgB64}`} />


                  </div>
                </div>
              }
              {getErrorMessage(props.validationErrorsList, 'fallbackImageModeImgB64')?.length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5 ml-2" aria-hidden="true" />

                {getErrorMessage(props.validationErrorsList, 'fallbackImageModeImgB64')}
                </div>
              }
              <FileSelector noDeleteButton
                text="Upload default image"
                onChange={(dataUrl) => {handleFallbackConditionChange('image', 'imgB64', dataUrl);}}
              />

            </div>

          </div>}

        {(snippetSettings.fallbackMode === 'parameters' || snippetSettings.fallbackMode === 'mixed') && <div className='mt-2 flex flex-row gap-x-12'>
            <div>
              <div className='flex flex-row items-center gap-x-1'>
                <div className='font-semibold'>Conditions</div>
                <InfoToolTip 
                        placement='right'
                        headLine='Multiple Parameters notice'
                        message="If your Element is using multiple parameters, it is enough that one meets the coditions below to apply the fallback."
                    />
              </div>
              <div className='flex flex-col'>
                <CcCheckbox
                    displayName={<div>Parameter is empty</div>}
                  checked={snippetSettings.fallback.parameters.isEmpty}
                  onChange={(e) => {handleFallbackConditionChange('parameters', 'isEmpty', e.target.checked);}}
                />
                <div className='flex flex-row items-center gap-x-1'>
                  <CcCheckbox
                      displayName={<div>Parameter is longer than</div>}
                    checked={snippetSettings.fallback.parameters.isLonger}
                    onChange={(e) => {handleFallbackConditionChange('parameters', 'isLonger', e.target.checked);}}
                  />
                  <div className='w-32 font-poppins'>
                    <InputNumber displayName="" small
                      min={1} max={100} incr={1}
                      onChange={(val) => {handleFallbackConditionChange('parameters', 'longer', val);}}
                      value={snippetSettings.fallback.parameters.longer}
                    />
                  </div>
                  <div>characters</div>
                
                </div>
                <div className='flex flex-row items-center gap-x-1'>
                  <CcCheckbox
                      displayName={<div>Parameter is shorter than</div>}
                    checked={snippetSettings.fallback.parameters.isShorter}
                    onChange={(e) => {handleFallbackConditionChange('parameters', 'isShorter', e.target.checked);}}
                  />
                  <div className='w-32 font-poppins'>
                    <InputNumber displayName="" small
                      min={1} max={100} incr={1}
                      onChange={(val) => {handleFallbackConditionChange('parameters', 'shorter', val);}}
                      value={snippetSettings.fallback.parameters.shorter}
                    />
                  </div>
                  <div>characters</div>
                
                </div>

              </div>
              {getErrorMessage(props.validationErrorsList, 'fallbackParametersModeAtLeastOneCheckbox')?.length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5 ml-2" aria-hidden="true" />

                {getErrorMessage(props.validationErrorsList, 'fallbackParametersModeAtLeastOneCheckbox')}
                </div>
              }
            </div>

            <div className='h-[330px] flex flex-col items-center gap-y-2'>
              <div className='font-semibold'>Default Parameter Values</div>
              <div>
                {snippetSettings.fallback.parameters.defaultParamsValues.map((pv, index) => <div className='flex flex-row items-center'>
                  <div>
                    <InputText
                        displayName={<div>Value for parameter: <span className=' italic'>{pv.pName}</span></div>}
                        value={pv.pValue}
                        onChange={(val) => {handleFallbackParametersChange(index, val);}}
                    />
                  </div>
                </div>)}
              </div>

            </div>

          </div>}
      </>
      }

    </div>
    }
  

</div>

</div>
  </div>
}

export default function TextImagesWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [preEditorProps, setPreEditorProps] = useState({});
    const [templateId, setTemplateId] = useState(null);
    const [templateHasTimeLabels, setTemplateHasTimeLabels] = useState(false); // we check if the selected template contains time labels (by checking its templateJson)
    const [templateJson, setTemplateJson] = useState({}); // we keep the template josn only to see if it contains time labels
    const [snippetData, setSnippetData] = useState({});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
  

    const getSnippetInfo = async (snippetId) => {
      /*
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);
        const data = response.data;


      const newTemplate = {...selectedTemplate}
      newTemplate.templateId = data.templateId;
      setSelectedTemplate(newTemplate);
      setSnippetName(data.snippetName)
      setSnippetDesc(data.description)
      setSelectedTimerDate(data.timerDate)
      setSelectedTimeZoneId(data.timerDateTimezoneIANA);
      setTimerSettings(JSON.parse(data.timerSetting));

      } catch (error) {
        console.log(error);
      }
      */
    }
    const templateContainsTimeLabels = (templateJson) => {
      let result = false;
      const blocks = templateJson.model.children[0].children;

      blocks.forEach(block => {
        if (block.className === "Text" && block.attrs.id.startsWith('timerLabel')) result = true;
      })
      console.log(result)
      return result;
    }

    const submitDataSnippet = async () => {
      try {
        snippetDataValidationSchemaBase.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        console.log(errorList)
        return false;
      }

      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/9`;
          
          const response = await axios.post(url, {...snippetData, snippetSettings: JSON.stringify(snippetData.snippetSettings)});
    
          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleTimerElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaBase.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }

  }
      
    const handleNavChange = async (navInfo) => {
        if (navInfo.actionType === 'Navigation'){
            setCurrentStep(navInfo.nextIndex);
        }
        else if (navInfo.actionType === 'Submit') {
            const success =  await submitDataSnippet();
            if (!success) return;
            setCurrentStep(3)
        }
      }
    
    const handleSaveExitClicked = () => {
        navigate("/ph/textImages")
    }
    const handleNextClicked = (tId, tJson) => {
        setTemplateId(tId)
        setTemplateJson(tJson)
        setTemplateHasTimeLabels(templateContainsTimeLabels(tJson));
        setCurrentStep(2);
    }
    const handleClose = () => {
        navigate("/ph/textImages")
    }
  
    const handlePreEditorChange = (propsDic) => {
        //console.log(propsDic)
        setPreEditorProps(propsDic)
    }

    return <div>
        <CcStepper2
            steps={[{ name: 'Configure Template', href: '#' },
                    { name: 'Finalize Template', href: '#' },
                    { name: 'Configure Element', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">
            {currentStep === 0 && 
                    <TextImagesPreEditor
                        templateProps={preEditorProps}
                        onChange={handlePreEditorChange}
                    />}

            {currentStep === 1 &&
                    <TemplateEditor id={templateId}
                    embeddedInWizard
                    onPreviousClicked={() => setCurrentStep(0)}
                    onSaveExitClicked={handleSaveExitClicked}
                    onNextClicked={handleNextClicked}
                    buildFromDictionary={preEditorProps}
                    //closingCall={() => {setAddEditMode(false); setTemplateIdToEdit(null)}}
                    snippetTypeId={9}

                    />
            }
            {currentStep === 2 && <TextImagesElementManager
                                    onChange={handleTimerElementChange}
                                    templateId={templateId}
                                    templateHasTimeLabels={templateHasTimeLabels}
                                    validationErrorsList={activeErrorList}
                                  />}

            {currentStep === 3 && <div className='flex justify-center'>
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <LionLoaderGradient /> }
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
            </div>}

            {currentStep !== 1 &&
                    <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}